/** @jsx jsx */
import { StaticQuery, graphql, Link } from 'gatsby';
import get from 'lodash/get';
//import { RichText } from "prismic-reactjs";
//import { PrismicRichText } from '@prismicio/react';
import { Box, Text, jsx } from 'theme-ui';
import Container from '../../../container/container';
import SocialLinks from '../../../social-links/social-links';
import styles from './footer.styles';

/*const footerStaticQuery = graphql`
	query {
	  allPrismicChat2Ordercommon {
		edges {
		  node {
			data {
			  copyright_text {
				richText
			  }
			  social_links {
				social_link {
				  url
				}
				social_type
			  }
			}
		  }
		}
	  }
	}
`;*/

const socialData = [{"type":"facebook","link":"https://www.facebook.com/p/R-Ghosh-and-Son-Jewellers-100064234861234/"},{"type":"twitter","link":"https://twitter.com/Chat2Order_in"},{"type":"instagram","link":"https://www.instagram.com/chat2orderadmin/"},{"type":"youtube","link":"https://www.youtube.com/@chat2order"}];
const copyright_text = "© Chat2Order by NCOM Digital Solutions LLP"
const getSocialData = (links) => {
	const data = [];
	links.forEach((link) => {
		data.push({ type: link.social_type, link: link.social_link.url });
	});
	return data;
};

const Footer: React.FC<{ fluid?: boolean }> = ({ fluid }) => {
	/*<StaticQuery<GatsbyTypes.Query>
		query={`${footerStaticQuery}`}
		render={(data) => {*/
			//const footerData = get(data, 'allPrismicChat2Ordercommon.edges[0].node.data');
			//const socialData = getSocialData(footerData.social_links);
			//console.log(`social: ${JSON.stringify(socialData)}`)
			//console.log(`social: ${JSON.stringify(footerData)}`)
			return (
				<Box as="footer" sx={styles.footer}>
					<Container fluid={fluid}>
						<Text className="copyright" sx={styles.copyright}>
							{copyright_text}
						</Text>
						<Link
							activeClassName="active"
							to={`/about`}
							sx={styles.about}
						>
							About Chat2Order
						</Link>	
						<Link
							activeClassName="active"
							to={`/seller`}
							sx={styles.about}
						>
							About us
						</Link>													
						<Link
							activeClassName="active"
							to={`/privacy`}
							sx={styles.about}
						>
							Privacy
						</Link>			
						<Link
							activeClassName="active"
							to={`/terms`}
							sx={styles.about}
						>
							Terms & Conditions 
						</Link>							
						<SocialLinks items={socialData} />
					</Container>
				</Box>
			);
		/*}}
	/>*/
};

export default Footer;
